import {
  DbotEvent,
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { DecisionType } from "@/common/decisions";
import {
  ChangeOfBusinessManager,
  ChangeOfBusinessManagerForm,
} from "./changeOfBusinessManagerDomain";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<ChangeOfBusinessManager>,
  data?: ChangeOfBusinessManager,
): ChangeOfBusinessManagerForm {
  return new ChangeOfBusinessManagerForm(dispatch, context, data);
}

export function handleEvent(form: ChangeOfBusinessManagerForm, event: DbotEvent) {
  form.handleEvent(event);
}

export function isValid(form: ChangeOfBusinessManagerForm): boolean {
  return form.isValid;
}

export function validate(form: ChangeOfBusinessManagerForm): boolean {
  return form.validate();
}

export function applyForm(form: ChangeOfBusinessManagerForm): ChangeOfBusinessManager {
  return {
    type: DecisionType.changeOfBusinessManager,
    name: form.selectedCompany?.name,
    organisationNumber: form.selectedCompany?.organizationnumber,
    businessAddress1: form.selectedCompany?.address,
    businessAddress2: form.selectedCompany?.address2,
    businessZip: form.selectedCompany?.zip,
    businessCity: form.selectedCompany?.city,
    businessCountry: form.selectedCompany?.sourceCountry,
    previousBusinessManager: form.data?.previousBusinessManager,
  };
}

export const changeOfBusinessManagerHandler: DecisionTypeHandler<
  DecisionType.changeOfBusinessManager,
  ChangeOfBusinessManager,
  ChangeOfBusinessManagerForm
> = {
  type: DecisionType.changeOfBusinessManager,
  initNewForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
